import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ReactNode } from 'react';
import { Controller, ControllerProps } from 'react-hook-form';

import { FormElementProps } from '@/components/form/types';

interface FormButtonGroupProps extends FormElementProps {
    toggleButtons: { label: string; value: string }[];
    buttonGroupProps?: Record<string, unknown>;
    buttonRenderer?: (item: { label: string; value: string }) => ReactNode;
    controllerProps?: Omit<ControllerProps, 'render' | 'name' | 'control'>;
}

export const FormButtonGroup = ({
    name,
    control,
    toggleButtons,
    buttonRenderer = ({ label }) => label,
    buttonGroupProps,
    controllerProps,
}: FormButtonGroupProps) => {
    return (
        <Controller
            name={name}
            control={control}
            {...controllerProps}
            render={({ field }) => {
                const handleChange = (event: React.MouseEvent<HTMLElement>, value: string) => {
                    if (value === null) {
                        // disallow unselecting. One button must always be selected.
                        return;
                    }
                    (event.target as HTMLInputElement).value = value;
                    field.onChange(event);
                };
                return (
                    <ToggleButtonGroup
                        {...field}
                        onChange={handleChange}
                        exclusive
                        aria-label={name}
                        size="small"
                        {...buttonGroupProps}
                    >
                        {toggleButtons.map((btn) => (
                            <ToggleButton key={`${btn.value}-${btn.label}`} value={btn.value} aria-label={btn.label}>
                                {buttonRenderer(btn)}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                );
            }}
        />
    );
};
